"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var ClearFailures_1 = require("../Actions/ClearFailures");
function useFailures() {
    var dispatch = (0, react_redux_1.useDispatch)();
    return [(0, react_redux_1.useSelector)(function (state) { return state.failures; }), function () { return dispatch((0, ClearFailures_1.clearFailures)()); }];
}
exports.default = useFailures;
//# sourceMappingURL=useFailures.js.map